import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export enum DATE_FORMATS_FNS {
  dateMonthYear = "dd-MM-yyyy",
  dateMonthYearSlash = "dd/MM/yyyy",
  dateMonthYearRange = "dd-MM-yyyy - dd-MM-yyyy",
  dateMonthYearTime = "dd-MM-yyyy HH:mm",
  timeDateMonthYearShort = "HH:mm dd-MM-yy",
  timeDateMonthYear = "HH:mm dd-MM-yyyy",
  yearMonthDateSlash = "yyyy/MM/dd",
  yearMonthDate = "yyyyMMdd",
  timeCarAppDate = "yyyy-MM-dd'T'12:00:00'Z'",
  ISOFormat = "yyyy-MM-dd'T'HH:mm:ssXXX",
  ISOFormatEndOfDay = "yyyy-MM-dd'T'23:59:59XXX",
  ISOFormatWithZ = "yyyy-MM-dd'T'HH:mm:ss'Z'",
  hoursMinutes = "HH:mm",
  hoursMinutesSeconds = "HH:mm:ss",
  dateMonthYearShort = "dd-MM-yy",
  yearMonthDateDash = "yyyy-MM-dd",
  yearMonthDatehoursMinutes = "yyyy-MM-dd HH:mm",
  dateMonthHoursMinutes = "dd-MM HH:mm",
  monthDayCommaYear = "MMM dd, yyyy",
  dateMonthYearDot = "dd.MM.yyyy",
  monthDayYear = "MM-dd-yyyy"
}

export const toDate = (date: string | Date) => (typeof date === "string" ? new Date(date) : date);
export const formatDate = (date: string | Date, formatString: DATE_FORMATS_FNS = DATE_FORMATS_FNS.ISOFormat) => format(toDate(date), formatString);
export const toISOString = (date: string | Date | null | undefined) => (date ? toDate(date) : new Date()).toISOString();

export const formatCurrentUTCDate = (formatString: DATE_FORMATS_FNS) => {
  const now = new Date();
  const utcDate = toZonedTime(now, "UTC");

  return format(utcDate, formatString).replace(/([+-]\d{2}:\d{2})$/, "+00:00");
};
